export class Publicacoes {
  tipIdTipo: number = null;
  idPublicacao: number = null;
  dtPublicacao: Date = null;
  sgClasse: string = null;
  dsProcesso: string = null;
  nmReu: string = null;
  nmAutor: string = null;
  snAtivo: string = null;
  snFtparq: string = null;
  nrNumero: number = null;
  nrAno: number = null;
  nmUsuario: string = null;
  nmRelator: string = null;
  nmRevisor: string = null;
  sisIdSistema: number = null;
  locIdLocal: number = null;
  docIdDoc: number = null;
  turCodigo: string = null;
  nmRedator: string = null;
  clsCodigo: string = null;
  proIdProcesso: number = null;

  constructor(d?) {
    this.tipIdTipo = d.tipIdTipo ? d.tipIdTipo : null;
    this.idPublicacao = d.idPublicacao ? d.idPublicacao : null;
    this.dtPublicacao = d.dtPublicacao ? d.dtPublicacao : null;
    this.sgClasse = d.sgClasse ? d.sgClasse : null;
    this.dsProcesso = d.dsProcesso ? d.dsProcesso : null;
    this.nmReu = d.nmReu ? d.nmReu : null;
    this.nmAutor = d.nmAutor ? d.nmAutor : null;
    this.snAtivo = d.snAtivo ? d.snAtivo : null;
    this.snFtparq = d.snFtparq ? d.snFtparq : null;
    this.nrNumero = d.nrNumero ? d.nrNumero : null;
    this.nrAno = d.nrAno ? d.nrAno : null;
    this.nmUsuario = d.nmUsuario ? d.nmUsuario : null;
    this.nmRelator = d.nmRelator ? d.nmRelator : null;
    this.nmRevisor = d.nmRevisor ? d.nmRevisor : null;
    this.sisIdSistema = d.sisIdSistema ? d.sisIdSistema : null;
    this.locIdLocal = d.locIdLocal ? d.locIdLocal : null;
    this.docIdDoc = d.docIdDoc ? d.docIdDoc : null;
    this.turCodigo = d.turCodigo ? d.turCodigo : null;
    this.nmRedator = d.nmRedator ? d.nmRedator : null;
    this.clsCodigo = d.clsCodigo ? d.clsCodigo : null;
    this.proIdProcesso = d.proIdProcesso ? d.proIdProcesso : null;
  }
}
